// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import Row from '@tcp/core/src/components/common/atoms/Row';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import theme from '@tcp/core/styles/themes/TCP';
import Anchor from '../../../../../../common/atoms/Anchor';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/ProfileInfoTileNew.style';
import Address from '../../../../../../common/molecules/Address';
import internalEndpoints from '../../../internalEndpoints';
import { isCanada, getIconPath } from '../../../../../../../utils';
import AccountCommonLabels, {
  ACCOUNT_LABELS,
  GLOBAL_LABELS,
} from '../../../labels/AccountCommon.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblEdit,
} from '../../../../../../../utils/labels/globalActions.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPassword,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const { breakpoints } = theme;

const ProfileInfoTileNew = ({ profileInfo, className }) => {
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);
  const { firstName, lastName, emailAddress, rewardsAccountNumber, address } = profileInfo;
  const isCA = isCanada();
  const CAROUSEL_OPTIONS = {
    autoplay: false,
    arrows: false,
    autoplaySpeed: 4000,
    infinite: false,
    initialSlide: 0,
    fade: false,
    speed: 300,
    dots: true,
    dotsClass: 'slick-dots',
    focusOnSelect: true,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: parseInt(breakpoints.medium, 10) - 1,
        settings: {
          autoplay: false,
          arrows: false,
          infinite: false,
          slidesToShow: 1.5,
          initialSlide: 0,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: parseInt(breakpoints.large, 10) - 1,
        settings: {
          autoplay: false,
          arrows: false,
          infinite: false,
          initialSlide: 0,
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const renderProfileInfoTile = () => {
    return (
      <div>
        <BodyCopy component="div" className="credit-card-new">
          <BodyCopy component="div" className="tileWrapper">
            <BodyCopy component="div">
              <BodyCopy component="div" fontSize="fs16" fontWeight="bold" fontFamily="secondary">
                {firstName}
                {` `}
                {lastName}
              </BodyCopy>

              {!isCA && (
                <BodyCopy component="div" className="expiry-card-number-container">
                  <BodyCopy
                    component="div"
                    fontSize="fs14"
                    fontWeight="normal"
                    fontFamily="secondary"
                  >
                    {rewardsAccountNumber}
                  </BodyCopy>
                  <BodyCopy
                    component="div"
                    className="card-expiry"
                    text
                    fontSize="fs10"
                    fontWeight="normal"
                    fontFamily="secondary"
                  >
                    {`${renderLabel(
                      accountLabels?.accountOverview?.lbl_overview_profileInfoMember,
                      'lbl_overview_profileInfoMember'
                    ).toUpperCase()} `}
                  </BodyCopy>
                </BodyCopy>
              )}
              <BodyCopy component="div" className={`${className} expiry-card-number-container`}>
                <BodyCopy
                  component="div"
                  fontSize="fs14"
                  fontWeight="normal"
                  fontFamily="secondary"
                  className="text-overflow-ellipsis"
                >
                  {emailAddress}
                </BodyCopy>
                <BodyCopy
                  component="div"
                  className="card-expiry"
                  text
                  fontSize="fs10"
                  fontWeight="normal"
                  fontFamily="secondary"
                >
                  {renderLabel(
                    globalLabels?.addEditAddress?.lbl_addEditAddress_email,
                    'lbl_addEditAddress_email'
                  ).toUpperCase()}
                </BodyCopy>
              </BodyCopy>
            </BodyCopy>
            <BodyCopy component="div">
              <Anchor
                underline
                to={internalEndpoints.editProfileInformationPage.link}
                asPath={internalEndpoints.editProfileInformationPage.path}
                dataLocator="userdetailsEditLnk"
                aria-label="Edit profile information"
                className="edit-link-card"
                useRouterNavigation
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                    GlobalActionsLabels
                  ),
                  'lbl_edit'
                )}
              </Anchor>
            </BodyCopy>
          </BodyCopy>
        </BodyCopy>
      </div>
    );
  };

  const renderMailingAddressTile = () => {
    return (
      <div>
        <BodyCopy component="div" className="credit-card-new">
          <BodyCopy component="div" className="tileWrapper">
            <BodyCopy component="div">
              <BodyCopy component="div" fontSize="fs16" fontWeight="bold" fontFamily="secondary">
                {renderLabel(
                  accountLabels?.accountOverview?.lbl_overview_profileInfoMailingAddress,
                  'lbl_overview_profileInfoMailingAddress'
                )}
              </BodyCopy>
              <BodyCopy component="div" className="expiry-card-number-container">
                <BodyCopy
                  component="div"
                  fontSize="fs14"
                  fontWeight="normal"
                  fontFamily="secondary"
                >
                  <Address
                    dataLocatorPrefix="mailingAddress"
                    showName={false}
                    showPhone={false}
                    showCountry={false}
                    address={address}
                  />
                </BodyCopy>
              </BodyCopy>
            </BodyCopy>
            <BodyCopy component="div">
              <Anchor
                underline
                to={internalEndpoints.mailingAddressPage.link}
                asPath={internalEndpoints.mailingAddressPage.path}
                dataLocator="userdetailsEditLnk"
                aria-label="Edit profile information"
                className="edit-link-card"
                useRouterNavigation
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                    GlobalActionsLabels
                  ),
                  'lbl_edit'
                )}
              </Anchor>
            </BodyCopy>
          </BodyCopy>
        </BodyCopy>
      </div>
    );
  };

  const renderPasswordTile = () => {
    return (
      <div>
        <BodyCopy component="div" className="credit-card-new">
          <BodyCopy component="div" className="tileWrapper">
            <BodyCopy component="div">
              <BodyCopy component="div" fontSize="fs16" fontWeight="bold" fontFamily="secondary">
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblPassword}`,
                    GlobalGenericLabels
                  ),
                  'lbl_password'
                )}
              </BodyCopy>
              <BodyCopy component="div" className="expiry-card-number-container">
                **********
              </BodyCopy>
            </BodyCopy>
            <BodyCopy component="div">
              <Anchor
                underline
                to={internalEndpoints.changePassowrdPage.link}
                asPath={internalEndpoints.changePassowrdPage.path}
                dataLocator="passwordChangeLnk"
                aria-label="Change password"
                className="edit-link-card"
                useRouterNavigation
              >
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                    GlobalActionsLabels
                  ),
                  'lbl_edit'
                )}
              </Anchor>
            </BodyCopy>
          </BodyCopy>
        </BodyCopy>
      </div>
    );
  };

  return (
    <BodyCopy component="div" className={`${className} profile-tile-info-main`}>
      <Row fullBleed className="profile-heading">
        <div className="profile-heading-left">
          <div className="profile-status-logo">
            <Image src={getIconPath('profile')} />
          </div>
          <span className="my-profile-heading">
            {' '}
            {renderLabel(
              accountLabels?.accountOverview?.lbl_overview_profileInformationHeading,
              'lbl_overview_profileInformationHeading'
            ).toUpperCase()}
          </span>
        </div>
        <Anchor
          to={'/account?id=profile'}
          asPath={'/account/profile'}
          className="profile-view-all"
          target={'_self'}
          dataLocator={'accountverview-earnExtaPointTitle-viewallcta'}
          useRouterNavigation
        >
          {renderLabel(globalLabels?.cartItemTile?.lbl_view_all, 'lbl_view_all')}
        </Anchor>
      </Row>
      <BodyCopy
        component="div"
        className={`${className} payment_carousel profile-tile-carousel-new`}
      >
        <Carousel
          options={CAROUSEL_OPTIONS}
          carouselConfig={{
            customArrowLeft: null,
            customArrowRight: null,
            arrow: 'small',
            type: 'light',
          }}
          carouselTheme="dark"
        >
          {[renderProfileInfoTile(), renderMailingAddressTile(), renderPasswordTile()]}
        </Carousel>
      </BodyCopy>
    </BodyCopy>
  );
};

ProfileInfoTileNew.propTypes = {
  profileInfo: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
};

ProfileInfoTileNew.defaultProps = {
  className: '',
};

export default withStyles(ProfileInfoTileNew, styles);
export { ProfileInfoTileNew as ProfileInfoTileNewVanilla };
